/* components/Progress.svelte generated by Svelte v3.32.1 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	set_style
} from "svelte/internal";

function create_fragment(ctx) {
	let div1;
	let div0;

	return {
		c() {
			div1 = element("div");
			div0 = element("div");
			attr(div0, "class", "inner svelte-1c5vg33");
			set_style(div0, "background-color", /*color*/ ctx[0]);
			set_style(div0, "width", /*_progress*/ ctx[1]);
			attr(div1, "class", "container svelte-1c5vg33");
			set_style(div1, "border-color", /*color*/ ctx[0]);
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, div0);
		},
		p(ctx, [dirty]) {
			if (dirty & /*color*/ 1) {
				set_style(div0, "background-color", /*color*/ ctx[0]);
			}

			if (dirty & /*_progress*/ 2) {
				set_style(div0, "width", /*_progress*/ ctx[1]);
			}

			if (dirty & /*color*/ 1) {
				set_style(div1, "border-color", /*color*/ ctx[0]);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div1);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { progress = 0.5 } = $$props;
	let { color = "white" } = $$props;
	let _progress;

	$$self.$$set = $$props => {
		if ("progress" in $$props) $$invalidate(2, progress = $$props.progress);
		if ("color" in $$props) $$invalidate(0, color = $$props.color);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*progress*/ 4) {
			$: $$invalidate(1, _progress = `${Math.floor(progress * 100).toFixed(4)}%`);
		}
	};

	return [color, _progress, progress];
}

class Progress extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { progress: 2, color: 0 });
	}
}

export default Progress;